<template>
  <DxDropDownButton id="account-button"
                    icon="user"
                    :items="accountItems"
                    :drop-down-options="{ width: '170px' }"
                    display-expr="text"
                    styling-mode="text"
                    @item-click="executeItemMethod"
  />
</template>

<script setup>
  import DxDropDownButton from 'devextreme-vue/drop-down-button'
  import { useRouter } from 'vue-router'
  import { useUserStore } from '@/stores/userStore.js'

  const userStore = useUserStore()
  const router = useRouter()

  // Download Basket feature temporarily disabled; hide Downloads menu option
  const accountItems = [
    // { text: 'Downloads', action: 'navigateToDownloads', icon: 'download' },
    { text: 'Logout', action: 'logout', icon: 'close' }
  ]

  function executeItemMethod(e) {
    if (e.itemData && e.itemData.action === 'logout') {
      userStore.logout()
    } else if (e.itemData && e.itemData.action === 'navigateToDownloads') {
      router.push({ name: 'userDownloads' })
    }
  }
</script>

<style lang="scss">
  #account-button {
    margin: 0.25rem;

    .dx-dropdownbutton-action.dx-button-has-icon .dx-icon.dx-icon-right{
      margin-inline-start: 0;
    }
  }
</style>
